import React, {useEffect, useState} from 'react';
import moment from 'moment';
import './BranchInfoModal.scss';
import {getImageUrl} from '../api/iposApi';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import Map from '../components/Map';
import FormattedPrice from '../components/FormattedPrice';
import {convertDotNetTimeToMomentDate} from '../helpers/dateTime';

const BranchInfoModal = ({ t, closeModal, onClose, onOk, branchInfo, costDelivery}) => {
  const [todayWorkingHours, setTodayWorkingHours] = useState(null);
  // const todayWorkingHours = branchInfo.DeliveryTimes ? branchInfo.DeliveryTimes.some(dt => dt.day_of_week === moment().day()) : null;

  useEffect(() => {
    if (!branchInfo.DeliveryTimes) {
      setTodayWorkingHours(null);
    } else {
      setTodayWorkingHours(branchInfo.DeliveryTimes.find(dt => dt.day_of_week === moment().day()));
    }

  }, []);

  const branchWazeLink = (branchInfo.latitude && branchInfo.longitude)
    ? `https://www.waze.com/ul?ll=${branchInfo.latitude}%2C${branchInfo.longitude}&navigate=yes&zoom=17`
    :`https://waze.com/ul?q=${branchInfo.Address}&navigate=yes&utm_campaign=default&utm_source=waze_website&utm_medium=lm_share_location`;

  return (
    <div className="branch-info-modal-content">
      <div className={ 'close-modal' } onClick={ closeModal }>
        <FontAwesomeIcon icon="times"  />
      </div>
      <Map areas={ branchInfo.Areas.map(area => area.points) } lat={ branchInfo.latitude } lon={ branchInfo.longitude } />
      <div className={ 'info-row' }>
        <div className={ 'branch-logo' }>
          <img src={ getImageUrl(branchInfo.LogoImageName) } className="img-responsive" alt="iPos Web Delivery" />
        </div>
        <div className={ 'branch-name' }>
          { branchInfo.PlaseName }
        </div>
      </div>
      {/*<div className={'info-row'}>*/}
      {/*  <div className={'address'}>*/}
      {/*    <FontAwesomeIcon icon={['fab', 'waze']} />*/}
      {/*    <a*/}
      {/*      target={'blank'}*/}
      {/*      href={'https://ul.waze.com/ul?place=ChIJH3w7GaZMHRURkD-WwKJy-8E&ll=32.08529990%2C34.78176760&navigate=yes&utm_campaign=default&utm_source=waze_website&utm_medium=lm_share_location'}*/}
      {/*    >*/}
      {/*      { branchInfo.Address }*/}
      {/*    </a>*/}
      {/*  </div>*/}
      {/*</div>*/}

      {/*<div className={'info-row'}>*/}
      {/*  <div className={'phone'}>*/}
      {/*    <FontAwesomeIcon icon="phone" />*/}
      {/*    <a href={`tel:${branchInfo.Phone}`}>{branchInfo.Phone}</a>*/}
      {/*  </div>*/}
      {/*</div>*/}

      <div className={ 'info-row' }>
        <div className={ 'info-label' }>{ t('branch_info.about') }</div>
        <div className={ 'about' } dangerouslySetInnerHTML={ { __html: branchInfo.Details.replace(/(?:\r\n|\r|\n)/g, '<br />') } }>
          {/*{ branchInfo.Details.replace(/(?:\r\n|\r|\n)/g, '<br />') }*/}
        </div>
      </div>

      <div className={ 'info-row' }>
        <div className={ 'info-label' }>{ t('branch_info.delivery_details') }</div>
        <div className={ 'delivery-details' }>

          { costDelivery && (
            <div className={ 'delivery-details-row' }>
              <div className={ 'delivery-details-label' }>
                { t('branch_info.details.delivery_item') }
              </div>
              <div className={ 'delivery-details-value' }>
                <FormattedPrice price={ costDelivery } />
              </div>
            </div>
          ) }

          <div className={ 'delivery-details-row' }>
            <div className={ 'delivery-details-label' }>
              { t('branch_info.details.minimum_order') }
            </div>
            <div className={ 'delivery-details-value' }>
              <FormattedPrice price={ branchInfo.MinDeliveryAmount } />
            </div>
          </div>

          <div className={ 'delivery-details-row' }>
            <div className={ 'delivery-details-label' }>
              { t('branch_info.details.delivery_time') }
            </div>
            <div className={ 'delivery-details-value' }>
              { branchInfo.DeliveryTime } { t('branch_info.details.min') }
            </div>
          </div>

          <div className={ 'delivery-details-row' }>
            <div className={ 'delivery-details-label' }>
              { t('branch_info.details.working_hours') }
            </div>
            { todayWorkingHours && (
              <div className={ 'delivery-details-value' }>
                {

                  (!todayWorkingHours.start_dt && !todayWorkingHours.end_dt)
                    ?
                    t('working_time.closed')
                    :
                    `${convertDotNetTimeToMomentDate(todayWorkingHours.start_dt).format('HH:mm')}
                      -
                     ${convertDotNetTimeToMomentDate(todayWorkingHours.end_dt).format('HH:mm')}`

                }
              </div>
            )}
          </div>

          <div className={ 'delivery-details-row' }>
            <div className={ 'delivery-details-label' }>
              { t('branch_info.details.call_us') }
            </div>
            <div className={ 'delivery-details-value' }>
              <a href={ `tel:${branchInfo.Phone}` }>{branchInfo.Phone}</a>
            </div>
          </div>

          <div className={ 'delivery-details-row' }>
            <div className={ 'delivery-details-label' }>
              { t('branch_info.details.address') }
            </div>
            <div className={ 'delivery-details-value' }>
              <a
                target={ 'blank' }
                href={ branchWazeLink }
              >
                { branchInfo.Address }
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BranchInfoModal;
